var map = {
	"./amplifyBroker.md": [
		4007,
		7
	],
	"./button.md": [
		3087,
		87
	],
	"./coPilot.md": [
		5754,
		754
	],
	"./diceGame.md": [
		8503,
		503
	],
	"./difference-between-gatsbyjs-and-nextjs.md": [
		3002,
		2
	],
	"./doorlock.md": [
		1318,
		318
	],
	"./future-of-javascript.md": [
		5307,
		307
	],
	"./how-to-get-10k-instagram-followers.md": [
		5814,
		814
	],
	"./incognito.md": [
		8807,
		807
	],
	"./nerfTurret.md": [
		5266,
		266
	],
	"./popular-javascript-library-in-2020.md": [
		3880,
		880
	],
	"./think-out-of-the-box.md": [
		8334,
		334
	],
	"./trending-designs-in-2020.md": [
		1763,
		763
	],
	"./vice.md": [
		741,
		741
	],
	"./web-automation-with-python-language.md": [
		1529,
		529
	],
	"./what-nodejs-can-do.md": [
		9315,
		324
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 45;
module.exports = webpackAsyncContext;